module.exports = __webpack_public_path__ + "img/vertical_4_7_3016.36db3015.png";